import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConstants } from 'src/app/common/constants/api-url.constant';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  constructor(private storageService: LocalStorageService, private http: HttpClient, private toasterService: MessageService) { }

  getPaymentInfo(orderId: string): Observable<any> {
    return this.http.post(ApiConstants.PAYMENT_INFO(orderId), null)
  }

  getInstallments(orderId: string): Observable<any> {
    return this.http.get(ApiConstants.PAYMENT_PLAN(orderId))
  }

  getOrderStatus(orderId: string): Observable<any> {
    return this.http.get(ApiConstants.ORDER_STATUS(orderId))
  }

  cancelOrder(orderId: string): Observable<any> {
    return this.http.post(ApiConstants.CANCEL_ORDER_REQUEST(orderId), null)
  }

  createSession(request: any): Observable<any> {
    const orderId = request.orderId;
    const userId = request.userId;
    const url = ApiConstants.CREATE_SESSION(orderId, userId);
    return this.http.post(url, request);
  }
  resultIndicatorStatus(request: any): Observable<any> {
    const resultIndicator = request.resultIndicator;
    const url = ApiConstants.RESULT_INDICATOR_STATUS(resultIndicator);
    return this.http.post(url, request);
  }
  getMPGSCreditCard(): Observable<any> {
    return this.http.get(ApiConstants.GET_MPGS_CREDITCARD);
  }
  getTransactionStatus(request: any): Observable<any> {
    return this.http.post(ApiConstants.GET_TRANSACTION_STATUS(), request);
  }

  showMessage(severityType: string, toastMessage: string) {
    this.toasterService.clear();
    this.toasterService.add({ severity: severityType, detail: toastMessage });
  }

}
